<template>
<div class="container-fluid">
    <!-- Header -->
    <div class="header">
        <span class="welcome">Xin chào: <b>{{ user }}</b></span>
        <a class="logout" @click="logoutTaiKhoan">Đăng xuất</a>
    </div>

    <!-- Tabs -->
    <div class="tabs">
        <button :class="{ active: activeTab === 1 }" @click="clickDanhMuc">
            QUẢN TRỊ DANH MỤC
        </button>
        <button :class="{ active: activeTab === 2 }" @click="clickBaiViet">
            QUẢN TRỊ BÀI VIẾT
        </button>
        <button @click="clickUploadImg">
            ĐẨY ẢNH LÊN SERVER
        </button>
        <button @click="showEnglish = !showEnglish">
            {{ showEnglish ? "ẨN TIẾNG ANH" : "HIỆN TIẾNG ANH" }}
        </button>
    </div>
    <div v-if="showUploadImgPopup" class="popup-overlay">

        <div class="popup-content" style="width: -WEBKIT-FILL-AVAILABLE;">
            <div class="w-100 d-flex justify-content-end"> <button style="align-items: end; background: none;width: 30px; height: 30px;  border-radius: 50%;  color: red; border: 3px solid;" @click="showUploadImgPopup = false">X</button>
            </div>
            <DayAnhLenServerPup> </DayAnhLenServerPup>

        </div>
    </div>
    <!-- Main -->
    <div class="container-fluid">
        <div class="row justify-content-around">
            <!-- Form -->
            <div class="card-cate list-section-cate col-12 col-md-7 p-5 ">
                <div class="form-group">
                    <label class="text-start">Tiêu đề bài viết <span class="sub">(tiếng Việt)</span></label>
                    <input type="text" v-model="form.titleVi" @keyup="onTitleKeyup" /> </div>
                <div class="form-group">
                    <label class="text-start">Tên tìm kiếm (VD: tran-viet-trung)</label>
                    <input type="text" v-model="form.title_vi_short" />
                </div>
                <div class="form-group">
                    <label class="text-start">Ảnh nhỏ <span class="sub">(tiếng Việt)</span></label>
                    <input type="text" v-model="form.img_vi" />
                </div>
                <div class="form-group">
                    <label class="text-start">Nội dung tóm tắt <span class="sub">(tiếng Việt)</span></label>
                    <input type="text" v-model="form.shortContent_vi" />
                </div>
                <div class="form-group">
                    <label class="text-start">Nội dung <span class="sub">(tiếng Việt)</span></label>
                    <!-- Replace with your rich text editor component if needed -->
                    <textarea id="editor1" v-model="form.content_vi" rows="8" style="width:100%"></textarea>
                </div>
                <div class="form-group mt-3">

                </div>

                <!-- Form tiếng Anh -->
                <div v-if="showEnglish">
                    <div class="form-group">
                        <label class="text-start">Tiêu đề bài viết <span class="sub">(tiếng Anh)</span></label>
                        <input type="text" v-model="form.titleEn" />
                    </div>

                    <div class="form-group">
                        <label class="text-start">Ảnh nhỏ <span class="sub">(tiếng Anh)</span></label>
                        <input type="text" v-model="form.img_en" />
                    </div>
                    <div class="form-group">
                        <label class="text-start">Nội dung tóm tắt <span class="sub">(tiếng Anh)</span></label>
                        <input type="text" v-model="form.shortContent_en" />
                    </div>
                    <div class="form-group">
                        <label class="text-start">Nội dung <span class="sub">(tiếng Anh)</span></label>
                        <textarea id="editor2" v-model="form.content_en" rows="8" style="width:100%; height: 800px;"></textarea>
                    </div>
                </div>
                <ul>
                    <li v-for=" cat in catParam" :key="cat.idDanhMucCha">
                        <strong class="category-link text-start">
                            {{ VMbase64Utf8(categories.find(c => c.id === cat.idDanhMucCha)?.title_vi || '') }}
                        </strong>
                        <span title="Vị trí">Vị trí </span>
                        <input type="number" v-model="cat.pos" />
                    </li>
                </ul>
                <div class="container-fluid p-0">
                    <div class="row">
                        <div class="form-group mt-3 col-12 col-md-8">
                            <input type="text" v-model="form.token" placeholder="Nhập 6 số token" />

                        </div>
                        <button style="margin: auto;" class="btn-primary col-12 col-md-4" @click="createBaiViet" :disabled="isLoading || form.id" v-if="!form.id">
                            + TẠO BÀI VIẾT
                        </button>
                        <button class="m-auto btn-primary col-12 col-md-4" @click="updateBaiViet" :disabled="isLoading || !form.id" v-if="form.id">
                            ✏️ CẬP NHẬT BÀI VIẾT
                        </button>
                    </div>
                </div>
            </div>
            <!-- List -->
            <div class="card-cate list-section col-12 col-md-4 p-4">
                <div class="w-100 d-flex justify-content-between" style="border-bottom: 2px solid #f0f0f0; text-align: start">
                    <div class="search-bar d-flex align-items-center w-50">
                        <input type="text" v-model="searchText" @input="onSearch" placeholder="Tìm kiếm bài viết..." class="search-input" />
                    </div>
                    <div class="pagination">
                        <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
                            Trước
                        </button>
                        <span>Trang {{ currentPage }}</span>
                        <button @click="goToPage(currentPage + 1)" :disabled="getnews.length < pageSize">
                            Sau
                        </button>
                    </div>
                </div>

                <ul>
                    <li v-for="(item, index) in filteredNews" :key="item.id">
                        <div class="d-flex flex-column w-100">
                            <div class=" w-100 d-flex justify-content-around">
                                <a href="#" class="category-link text-start" @click.prevent="editBaiViet(item)">
                                    Bài {{ (currentPage - 1) * pageSize + index + 1 }} -
                                    {{ VMbase64Utf8(item.title_vi) }}
                                </a>
                                <div class="d-flex">
                                    <span class="icon edit" title="Sửa" @click="editBaiViet(item)"></span>
                                    <span class="icon delete" title="Xóa" @click="confirmDelete(item)"></span>
                                </div>
                            </div>
                            <span class="text-start mt-2" style="font-size: 12px; color: #888;">ID: {{ item.id }}</span>
                        </div>
                    </li>
                </ul>
                <!-- Popup xác nhận xóa -->
                <div v-if="showDeletePopup" class="popup-overlay">
                    <div class="popup-content">
                        <h5>Bạn có muốn xóa bài viết?</h5>
                        <p><b>{{ VMbase64Utf8(deleteItem?.title_vi || '') }}</b></p>

                        <label>Nhập token xác nhận:</label>
                        <input type="text" v-model="deleteToken" />

                        <div class="popup-actions">
                            <button @click="deleteBaiViet">Xác nhận</button>
                            <button @click="showDeletePopup = false">Hủy</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<div v-if="isLoading" class="loading-overlay">
    <div class="loading-spinner"></div>
    <div class="loading-text">Đang xử lý...</div>
</div>
</template>

<script>
import {
    apiChiTietBaiViet,
    KEY_PHONE_ID
} from "@/components/listService";
import {
    postCreateBaiViet,
    postDeleteBaiViet,
    postListBaiViet,
    postListCateBaiViet,
    postUpdateBaiViet
} from "@/components/VimassCrop";
import axios from "axios";
import DayAnhLenServerPup from "../Vimass/Home/DayAnhLenServerPup.vue";

export default {
    name: "QuanTriBaiViet",
    components: {
        DayAnhLenServerPup
    },
    data() {
        return {
            activeTab: 2,
            form: {
                id: null,
                titleVi: "",
                titleEn: "",
                title_vi_short: "",
                img_vi: "",
                shortContent_vi: "",
                content_vi: "",
                img_en: "",
                shortContent_en: "",
                content_en: "",
                order: 0,
                token: ""
            },
            showEnglish: false,
            ckEditor: null,
            ckEditorEn: null,
            user: "",
            getnews: [],
            catParam: [{
                idDanhMucCha: '',
                pos: 0,
            }],
            currentPage:1,
            pageSize: 50,
            categories: [

            ],
             searchText: "",
            showDeletePopup: false,
            deleteItem: null,
            deleteToken: "",
            isLoading: false,
            filteredNews: [],
            showUploadImgPopup: false,
        };
    },
    mounted() {
        this.getListBaiViet();
        this.getListCategory();
        this.user = localStorage.getItem(KEY_PHONE_ID);
        if (this.user == '' || this.user == null || this.user == undefined) {
            window.location.href = "/quantri/dangnhap";
        }

        if (window.CKEDITOR) {
            this.ckEditor = window.CKEDITOR.replace("editor1", {
                allowedContent: true,
                height: 600
            });

            // Khi nội dung CKEditor thay đổi, cập nhật contentBaiViet
            this.ckEditor.on("change", () => {
                this.form.content_vi = this.ckEditor.getData();
            });

            // this.ckEditorEn = window.CKEDITOR.replace("editor2", {
            //     allowedContent: true
            // });
            // this.ckEditorEn.on("change", () => {
            //     this.form.content_en = this.ckEditorEn.getData();
            // });
        } else {
            console.error(
                "CKEditor chưa được load. Hãy kiểm tra lại việc import CKEditor."
            );
        }
    },
    beforeUnmount() {
        // destroy cả hai editor nếu tồn tại
        if (this.ckEditor) {
            try {
                this.ckEditor.destroy();
            } catch (e) {
                /* ignore */
            }
            this.ckEditor = null;
        }
        if (this.ckEditorEn) {
            try {
                this.ckEditorEn.destroy();
            } catch (e) {
                /* ignore */
            }
            this.ckEditorEn = null;
        }
    },
    watch: {
        showEnglish(newVal) {
            if (newVal) {
                // sau khi phần tử được render vào DOM
                this.$nextTick(() => {
                    this.initEditor2();
                });
            } else {
                // khi ẩn, giải phóng instance ckEditorEn để tránh lỗi hay rò rỉ memory
                this.destroyEditor2();
            }
        }
    },
    methods: {
                onSearch() {
            const keyword = this.searchText.trim().toLowerCase();
            if (!keyword) {
                this.filteredNews = this.getnews;
                return;
            }
            this.filteredNews = this.getnews.filter(item =>
                this.VMbase64Utf8(item.title_vi || "").toLowerCase().includes(keyword)
            );
        },
        async getListBaiViet(page = 1) {
            let offset = (page - 1) * this.pageSize;
            let limit = this.pageSize;
            let langId = "0";
            let res = await postListBaiViet(limit, offset, langId);
            this.getnews = res.result;
            this.filteredNews = res.result; // cập nhật danh sách lọc khi load mới
            this.currentPage = page;
            this.onSearch() ; 
        },
        goToPage(page) {
            if (page < 1) return;
            if (page > this.currentPage && this.getnews.length < this.pageSize)
                return;
            this.getListBaiViet(page);
        },
        initEditor2() {
            if (!window.CKEDITOR) {
                console.error('CKEditor chưa load');
                return;
            }
            // tránh init lại nhiều lần
            if (this.ckEditorEn) {
                // nếu đã tồn tại, đảm bảo nội dung được cập nhật
                this.ckEditorEn.setData(this.form.content_en || '');
                return;
            }

            // kiểm tra phần tử thực sự có trong DOM
            if (!document.getElementById('editor2')) {
                console.warn('#editor2 chưa có trong DOM');
                return;
            }

            this.ckEditorEn = window.CKEDITOR.replace('editor2', {
                allowedContent: true,
                height: 600
            });
            this.ckEditorEn.on('change', () => {
                this.form.content_en = this.ckEditorEn.getData();
            });

            // nếu đã có dữ liệu, set vào editor
            if (this.form.content_en) {
                this.ckEditorEn.setData(this.form.content_en);
            }
        },

        destroyEditor2() {
            if (this.ckEditorEn) {
                try {
                    this.ckEditorEn.destroy();
                } catch (e) {
                    /* ignore */
                }
                this.ckEditorEn = null;
            }
        },
        clickUploadImg() {
            this.showUploadImgPopup = !this.showUploadImgPopup;
        },

        toSlug(str) {
            if (!str) return "";
            return str
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "") // bỏ dấu tiếng Việt
                .replace(/[^a-z0-9\s-]/g, "") // bỏ ký tự đặc biệt
                .replace(/\s+/g, "-") // thay khoảng trắng bằng -
                .replace(/-+/g, "-") // bỏ trùng dấu -
                .replace(/^-+|-+$/g, ""); // bỏ - đầu/cuối
        },
        onTitleKeyup() {
            this.form.title_vi_short = this.toSlug(this.form.titleVi);
        },
        logoutTaiKhoan() {
            localStorage.removeItem(KEY_PHONE_ID);
            window.location.href = "/quantri/dangnhap";
        },
        clickBaiViet() {
            window.location.href = "/quantri/baiviet";
        },
        clickDanhMuc() {
            window.location.href = "/quantri/trangchu";
        },
        async editBaiViet(item) {
            this.isLoading = true;
            const response = await axios.post(apiChiTietBaiViet, {
                id: item.id,
                langId: "0",
            });

            // Gán dữ liệu vào form
            this.form = {
                id: item.id, // lưu id để update
                titleVi: this.VMbase64Utf8(item.title_vi || ""),
                titleEn: this.VMbase64Utf8(item.title_en || ""),
                title_vi_short: item.title_vi_short || "",
                img_vi: item.img_vi || "",
                shortContent_vi: this.VMbase64Utf8(item.shortContent_vi || ""),
                content_vi: this.VMbase64Utf8(response.data.result.content_vi || ""),
                img_en: item.img_en || "",
                shortContent_en: this.VMbase64Utf8(item.shortContent_en || ""),
                content_en: this.VMbase64Utf8(response.data.result.content_en || ""),
                order: item.order || 0,
                token: ""
            };
            this.catParam = this.categories.map(cat => {
                // Tìm vị trí mới trong response, nếu có thì lấy, không thì 0
                const found = (response.data.result.catParam || []).find(x => x.idDanhMucCha === cat.id);
                return {
                    idDanhMucCha: cat.id,
                    pos: found ? found.pos : 0
                };
            });
            this.isLoading = false;

            // Nếu đang dùng CKEditor thì set lại content
            if (this.ckEditor) {
                this.ckEditor.setData(this.form.content_vi);
            }
            if (this.ckEditorEn) {
                this.ckEditorEn.setData(this.form.content_en);
            }
        },

        async updateBaiViet() {
            this.isLoading = true;

            if (!this.form.token) {
                alert("Vui lòng nhập token xác nhận!");
                return;
            }
            try {
                let res = await postUpdateBaiViet(
                    this.user,
                    this.form.titleVi,
                    this.form.title_vi_short,
                    this.form.img_vi,
                    this.form.shortContent_vi,
                    this.form.content_vi,
                    this.form.titleEn,
                    this.form.img_en,
                    this.form.shortContent_en,
                    this.form.content_en,
                    this.form.token,
                    this.catParam,
                    this.form.id // truyền id để update
                );
                if (res.msgCode !== 1) {
                    alert("Cập nhật bài viết thất bại! " + res.msgContent);
                    return;
                }
                alert("Cập nhật bài viết thành công!");
                this.getListBaiViet();
                this.isLoading = false;

            } catch (e) {
                console.error("Lỗi cập nhật bài viết:", e);
                alert("Có lỗi xảy ra khi cập nhật.");
            }
        },
        confirmDelete(item) {
            this.deleteItem = item;
            this.deleteToken = "";
            this.showDeletePopup = true;
        },

        async deleteBaiViet() {
            if (!this.deleteToken) {
                alert("Vui lòng nhập token xác nhận!");
                return;
            }
            this.isLoading = true;

            try {
                let res = await postDeleteBaiViet(this.user, this.deleteItem.id, this.deleteToken);

                if (res.msgCode === 1) {
                    alert("Đã xóa thành công!");
                    this.showDeletePopup = false;
                    this.getListBaiViet(this.currentPage);
                    this.isLoading = false;
                } else {
                    alert("Xóa thất bại: " + res.msgContent);
                }
            } catch (e) {
                console.error("Lỗi xóa bài viết:", e);
                alert("Có lỗi xảy ra khi xóa.");
            }
        },

        async getListCategory() {
            let offset = "0";
            let limit = "20";
            let langId = "0";
            let res = await postListCateBaiViet(limit, offset, langId);
            this.categories = res.result;
            this.catParam = this.categories.map(item => ({
                idDanhMucCha: item.id,
                pos: 0
            }));
        },
        async createBaiViet() {
            this.isLoading = true;

            let res = await postCreateBaiViet(
                this.user,
                this.form.titleVi,
                this.form.title_vi_short,
                this.form.img_vi,
                this.form.shortContent_vi,
                this.form.content_vi,
                this.form.titleEn,
                this.form.img_en,
                this.form.shortContent_en,
                this.form.content_en,
                this.form.token,
                this.catParam
            );

            if (res.msgCode !== 1) {
                alert("Tạo bài viết thất bại! " + res.msgContent);
                return;
            }
            this.isLoading = false;

            alert("Tạo bài viết  thành công!");
            this.getListBaiViet();
        },

        VMbase64Utf8(str) {
            if (!str || typeof str !== "string") return "";
            try {
                const binary = atob(str);
                const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
                return new TextDecoder().decode(bytes);
            } catch (e) {
                return "";
            }
        },

        // extraString(str){
        //   return atob(str);
        // }
    },
};
</script>

<style scoped>
#cke_1_contents {
    height: 400px !important;
}

.card-cate {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.card-title {
    font-size: 18px;
    font-weight: 600;
    color: #176a94;
    margin-bottom: 15px;

    padding-bottom: 6px;
    text-align: start;
}

/* Header */
.header {
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    margin-top: 0px;
}

.logout {
    color: #ff4d4f;
    font-weight: 600;
    text-decoration: none;
}

.logout:hover {
    text-decoration: underline;
}

/* Tabs */
.tabs {
    display: flex;
    gap: 8px;
    margin-bottom: 20px;
}

.tabs button {
    background: #f5f5f5;
    color: #444;
    border: 1px solid #ddd;
    padding: 10px 20px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    border-radius: 8px 8px 0 0;
    transition: all 0.2s;
    line-height: 1;
}

.tabs button:hover {
    background: #e6f7ff;
}

.tabs button.active {
    background: #176a94;
    color: #176a94;
    border-color: #176a94;
}

/* Main */
.main-content {
    display: flex;
    gap: 30px;
    align-items: flex-start;
}

.form-section {
    flex: 1;
    max-width: 500px;
}

.form-group {
    margin-bottom: 12px;
}

.form-group label {
    font-weight: 600;
    display: block;
    margin-bottom: 4px;
}

.form-group .sub {
    font-weight: normal;
    font-size: 12px;
    color: #888;
}

.form-group input {
    width: 100%;
    padding: 8px 10px;
    border: 1px solid #ddd;
    border-radius: 6px;
    transition: 0.2s;
}

.form-group input:focus {
    border-color: #176a94;
    outline: none;
    box-shadow: 0 0 4px rgba(23, 106, 148, 0.2);
}

.btn-primary {
    background: #176a94;
    color: #fff;
    border: none;
    padding: 10px 25px;
    font-weight: 600;
    border-radius: 6px;
    cursor: pointer;
    margin-top: 10px;
    transition: 0.2s;
}

.btn-primary:hover {
    background: #145b7e;
}

/* List */
.list-section ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.list-section li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f0f0f0;
    padding: 10px 0;
    font-size: 16px;
}

.category-link {
    color: #176a94;
    font-weight: 500;
    text-decoration: none;
    flex: 1;
}

.category-link:hover {
    text-decoration: underline;
}

/* Icons */
.icon {
    display: inline-block;
    width: 22px;
    height: 22px;
    margin-left: 6px;
    cursor: pointer;
}

.pagination {
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: flex-end;
}

.pagination button {
    padding: 8px 20px;
    border-radius: 8px;
    border: 1px solid #176a94;
    background: #fff;
    color: #176a94;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    font-size: 15px;
}

.pagination button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.pagination button:hover:not(:disabled) {
    background: #176a94;
    color: #fff;
}

.pagination span {
    font-weight: 600;
    color: #176a94;
    font-size: 15px;
}

.icon.edit {
    background: url('data:image/svg+xml;utf8,<svg fill="green" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M7 17l5-5-2-2-5 5v2h2zm9.71-9.71a1.003 1.003 0 0 0-1.42 0l-1.34 1.34 2.12 2.12 1.34-1.34a1.003 1.003 0 0 0 0-1.42l-1.7-1.7z" fill="white"/></svg>') no-repeat center/contain;
}

.icon.delete {
    background: url('data:image/svg+xml;utf8,<svg fill="red" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M15.5 8.5l-7 7m0-7l7 7" stroke="white" stroke-width="2"/></svg>') no-repeat center/contain;
}

.list-section-cate ul {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    list-style: none;
    padding: 0;
    margin: 0;
}

.list-section-cate li {
    background: #f7fbfd;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(23, 106, 148, 0.06);
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 10px;
    border: none;
    font-size: 16px;
}

.popup-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
    animation: fadeIn 0.25s ease-in-out;
}

.popup-content {
    background: #fff;
    border-radius: 12px;
    padding: 24px;
    width: 420px;
    max-width: 90%;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    text-align: center;
    animation: scaleIn 0.25s ease-in-out;
}

.popup-content h5 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
    color: #333;
}

.popup-content p {
    font-size: 14px;
    margin-bottom: 16px;
    color: #555;
}

.popup-content label {
    display: block;
    font-size: 14px;
    text-align: left;
    margin-bottom: 6px;
    color: #444;
}

.popup-content input {
    width: 100%;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid #ccc;
    outline: none;
    transition: 0.2s;
    font-size: 14px;
}

.popup-content input:focus {
    border-color: #4a90e2;
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.25);
}

.popup-actions {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}

.popup-actions button {
    padding: 8px 18px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background 0.25s, transform 0.15s;
}

.cke_contents {
    height: 800px !important;
}

.popup-actions button:hover {
    transform: translateY(-1px);
}

.popup-actions button:first-child {
    background: #4a90e2;
    color: #fff;
}

.popup-actions button:first-child:hover {
    background: #3b7dc6;
}

.popup-actions button:last-child {
    background: #f0f0f0;
    color: #333;
}

.popup-actions button:last-child:hover {
    background: #e0e0e0;
}

/* Hiệu ứng */
@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes scaleIn {
    from {
        transform: scale(0.9);
        opacity: 0;
    }

    to {
        transform: scale(1);
        opacity: 1;
    }
}

.loading-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.25);
    z-index: 2000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.loading-spinner {
    width: 48px;
    height: 48px;
    border: 6px solid #e0e0e0;
    border-top: 6px solid #176a94;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
}

.loading-text {
    color: #176a94;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

@media (max-width: 600px) {
    .list-section-cate ul {
        grid-template-columns: 1fr !important;
        gap: 10px;
    }

    .list-section-cate li {
        font-size: 15px;
        padding: 10px;
        flex-direction: column;
        align-items: flex-start;
    }

    .category-link {
        margin-bottom: 6px;
    }

    .list-section-cate input[type="number"] {
        width: 100%;
        margin-top: 4px;
    }
}
</style>
